export interface PhaseBearingWorkPackage {
  id: string;
  phaseId?: string | null;
}

export function requireExecutionPhaseId(
  workPackage: PhaseBearingWorkPackage,
): string {
  const phaseId = workPackage.phaseId?.trim();

  if (!phaseId) {
    throw new Error(`EXECUTION_JOB_PHASE_ID_REQUIRED:${workPackage.id}`);
  }

  return phaseId;
}
